import {DateModel, TimestampsModel} from "../../models";
import {TransformBase} from "../TranformBase";

export class DatesTransform extends TransformBase {
  public makeDateModel(dto: string): DateModel {
    return this.same<DateModel>(dto);
  }

  public makeTimestampsModel<
    C extends boolean = true,
    U extends boolean = true,
  >(dto: {created_at?: string; updated_at?: string}): TimestampsModel<C, U> {
    const model: TimestampsModel<C, U> = {
      createdAt: dto.created_at ?? null,
      updatedAt: dto.updated_at ?? null,
    } as TimestampsModel<C, U>;

    return model;
  }
}

export const datesTransform = new DatesTransform();
